import { render, staticRenderFns } from "./HelpCalculatingMethod.vue?vue&type=template&id=49ffe966"
import script from "./HelpCalculatingMethod.vue?vue&type=script&lang=js"
export * from "./HelpCalculatingMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports